/**
 * Labstep
 *
 * @module components/Filter/Active/WithSort
 * @desc Container for active filter and sort
 */

import { EntityTableSortOptionsActive } from 'labstep-web/components/Entity/Table/SortOptions/Active';
import { FilterActive } from 'labstep-web/components/Filter/Active';
import { getHasFilterActive } from 'labstep-web/components/Filter/Active/utils';
import { useParamsContext } from 'labstep-web/contexts/params/hook';
import { useParamsStateContext } from 'labstep-web/contexts/params-state/hook';
import { ActionComponentModalContainer as ActionComponent } from 'labstep-web/core/Action/Component';
import type React from 'react';
import styles from './styles.module.scss';
import type { FilterActiveWithSortProps } from './types';

export const FilterActiveWithSort: React.FC<
  FilterActiveWithSortProps
> = ({ sortOptions, defaultSortOptions }) => {
  const {
    setParams,
    clearAll,
    searchParams,
    clearParams,
    setPostFilterNodeType,
    removePostFilter,
  } = useParamsContext();
  const { entityView } = useParamsStateContext();

  return (
    <div className={styles.container}>
      <FilterActive
        setParams={setParams}
        searchParams={searchParams}
        clearParams={clearParams}
        setPostFilterNodeType={setPostFilterNodeType}
        removePostFilter={removePostFilter}
        clearAll={clearAll}
        entityView={entityView}
      />
      {sortOptions && (
        <EntityTableSortOptionsActive
          searchParams={searchParams}
          clearParams={clearParams}
          sortOptions={sortOptions}
          setParams={setParams}
          defaultSortOptions={defaultSortOptions}
        />
      )}
      {getHasFilterActive(searchParams) ? (
        <ActionComponent
          type="text"
          text="Clear all"
          onClick={(): void => {
            clearAll([
              'folder_id',
              'is_unsorted',
              'template_id',
              'sort',
            ]);
          }}
        />
      ) : null}
    </div>
  );
};
